module.exports = __webpack_public_path__ + "img/game_main_pc_35_off.9aad7f79.png";